import script from "./ProductTiles.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductTiles.vue?vue&type=script&setup=true&lang=js"

import "./ProductTiles.vue?vue&type=style&index=0&id=fff034b8&scoped=true&lang=css"
import "./ProductTiles.vue?vue&type=style&index=1&id=fff034b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fff034b8"]])

export default __exports__